import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { URL_SERVICIOS } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ClientesService } from '../clientes/clientes.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public _url: string = `${URL_SERVICIOS}clientes`;
  public user = null;
  public token = null;
  public permisos = [];
  constructor(private http: HttpClient, private router: Router,
    private _loaderService : NgxUiLoaderService,) {
    this.check_storage();
  }

  login(usr: string, password: string) {
    return this.http.post(`${this._url}/login`, { user: usr, password }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }

  save_storage(user, token) {
    localStorage.setItem('tdo_cliente_user', JSON.stringify(user));
    localStorage.setItem('tdo_cliente_token', token);
    this.user = user;
    this.token = token;
  }

  actualizar_datos() {
    this.getById(this.user.id).subscribe((res: any) => {
      console.log('OBTENIENDO CLIENTE', res);
      if (!!res.result) {
        if (`${res.result.estado_cuenta}` != '0') {
          this.save_storage(res.result, this.token);
        } else {
          this.logout();
        }
      }
    });
  }
  getById(id: string) {
    return this.http.get(`${this._url}/byid/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }

  check_storage() {
    if (
      !!localStorage.getItem('tdo_cliente_user') &&
      !!localStorage.getItem('tdo_cliente_token')
    ) {
      this.user = JSON.parse(localStorage.getItem('tdo_cliente_user'));
      this.token = localStorage.getItem('tdo_cliente_token');
      this.actualizar_datos();

      return true;
    } else {
      return false;
    }
  }

  logout() {
    this._loaderService.start();
    this.user = null;
    this.token = null;
    //if (this.check_storage()) {
    //  localStorage.removeItem('tdo_cliente_user');
    //  localStorage.removeItem('tdo_cliente_token');
    //  this.router.navigate(['/home']);
    //} else {
      localStorage.removeItem('tdo_cliente_user');
      localStorage.removeItem('tdo_cliente_token');
      this.router.navigate(['/home']);
    //}
    this._loaderService.stop();
  }
}
